import React, { useEffect } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getaOrder } from "../features/auth/authSlice";

const ViewOrder = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const orderId = location.pathname.split("/")[3];

  useEffect(() => {
    dispatch(getaOrder(orderId));
  }, [dispatch, orderId]);

  const orderState = useSelector(
    (state) => state?.auth?.singleorder?.orders
  );

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    { title: "SNo", dataIndex: "key" },
    { title: "Product Name", dataIndex: "name" },
    { title: "Brand", dataIndex: "brand" },
    { title: "Size", dataIndex: "size" },
    { title: "Quantity", dataIndex: "quantity" },
    { title: "Price", dataIndex: "price" },
    { title: "Track Order", dataIndex: "track" },
  ];

  /* ================= TABLE DATA ================= */
  const dataSource =
    orderState?.orderItems?.map((item, index) => ({
      key: index + 1,
      name: item?.product?.title,
      brand: item?.product?.brand,
      size: item?.size,
      quantity: item?.quantity,
      price: `₹${item?.price}`,
      track: orderState?.shipUrl ? (
        <a
          href={orderState?.shipUrl?.length > 12 ? orderState?.shipUrl : `https://shiprocket.co/tracking/${orderState?.shipUrl}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      ) : (
        "N/A"
      ),
    })) || [];

  return (
    <div>
      <h3 className="mb-4 title">View Order</h3>

      {/* ================= ORDER DETAILS ================= */}
      <div className="mb-4">
        <h4>Order Information</h4>
        <p><b>Order ID:</b> {orderState?._id}</p>
        <p><b>Status:</b> {orderState?.orderStatus}</p>
        <p><b>Total Price:</b> ₹{orderState?.totalPrice}</p>
        <p><b>Discounted Price:</b> ₹{orderState?.totalPriceAfterDiscount}</p>
        <p><b>Payment Method:</b> {orderState?.shippingInfo?.paymentMethod}</p>
        <p>
          <b>Paid At:</b>{" "}
          {orderState?.paidAt
            ? new Date(orderState.paidAt).toLocaleString()
            : "N/A"}
        </p>
      </div>

      {/* ================= USER DETAILS ================= */}
      <div className="mb-4">
        <h4>Customer Information</h4>
        <p>
          <b>Name:</b>{" "}
          {orderState?.user?.firstname} {orderState?.user?.lastname}
        </p>
        <p><b>Email:</b> {orderState?.user?.email}</p>
        <p><b>Mobile:</b> {orderState?.user?.mobile}</p>
      </div>

      {/* ================= SHIPPING DETAILS ================= */}
      <div className="mb-4">
        <h4>Shipping Address</h4>
        <p>
          {orderState?.shippingInfo?.address},{" "}
          {orderState?.shippingInfo?.city},{" "}
          {orderState?.shippingInfo?.state},{" "}
          {orderState?.shippingInfo?.country} -{" "}
          {orderState?.shippingInfo?.pincode}
        </p>
      </div>

      {/* ================= ORDER ITEMS TABLE ================= */}
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </div>
  );
};

export default ViewOrder;
